import { Platform } from 'react-native';

import Color from 'react-native-material-color';

// colors
export const appColor = '#b8b05e';
export const secondColor = '#6C2547';
export const statusBarColor = Color.BLUE[700];

// Company Statics
export const company_phone = '0796200026';
export const company_app_url =
  Platform.OS === 'android'
    ? 'https://play.google.com/store/apps/details?id=com.puresoft.mojebfarm'
    : 'https://itunes.apple.com/app/id1451399537';

// Urls
export const serverBaseUrl = 'https://sales.jdsco.net:8444';
export const serverPublicBaseUrl = 'https://sales.jdsco.net:8444';
export const pickServerUrl = serverBaseUrl + '/pick/faces/redirect/jdsco?';
export const pickPublicServerUrl = serverPublicBaseUrl + '/pick/faces/redirect/jdsco?';
export const CURRENT_SERVER = "CURRENT_SERVER";
export const CURRENT_SERVER_IP = "CURRENT_SERVER_IP";

// User
export const email = 'email';
export const username = 'username';
export const password = 'password';
export const firstName = 'firstName';
export const lastName = 'lastName';
export const birthdate = 'birthdate';
export const gender = 'gender';
export const mobile = 'mobile';
export const location = 'location';
export const locations = 'locations';
export const maritalStatus = 'maritalStatus';
export const numOfChildren = 'numOfChildren';
export const address = 'address';
export const loggedIn = 'loggedIn';
export const isAdmin = 'isAdmin';
export const addressNote = 'addressNote';

// Logged in
export const LOGGED_IN = '1';
export const LOGGED_OUT = '0';

// Actions
export const GET_ITEMS = 'ITEMS';
export const GET_USERS = 'GET.USERS';
export const CALC_ORDER = 'CALC.ORD';
export const PLACE_ORDER = 'PLACE.ORD';
export const CONFIRM_ORDER = 'ORDER';
export const REGISTER = 'REGISTER';
export const GET_OTP = 'GET.OTP';
export const USER_INFO = 'USERINFO';
export const USERORDERS = 'ORDERS';
export const VIEWORDER = 'ORDERDET';
export const REG_DEV = 'REGDEV';
export const RATE = 'RATE';
export const RCVNEWS = 'RCVNEWS';
export const OFFERS = 'ADV';
export const CANCEL_ORDER = 'CANCEL.ORDER';
export const CAN_MODIFY = 'CAN.MODIFY';
export const FORGOT = 'FORGOT';
export const NOTIFICATIONS = 'NOTIFICATIONS';
export const DLVTIMES = 'DLVTIMES';
export const DRIVER_UPDATE_STATE = 'DRIVER_UPDATE_STATE';
export const INVOICE = 'INVOICE';
export const POSTINVOICE = 'POSTINVOICE';
export const GETLOCATION = 'GET.LOCATION';
export const GETLOCATIONHIST = 'GET.LOCATION.HIST';
export const GET_MIN_ORD = 'GET.MIN.ORD';
export const OUT_OF_STOCK_MESSAGE = 'OUT.OF.STOCK.MESSAGE';
export const NEW_ORDER_MESSAGE = 'NEW.ORDER.MESSAGE';
export const GET_CATEGORIES = 'CATEGORIES';
export const GET_FILTERS = 'FILTERS';
export const GET_BRANDS = 'GET.BRANDS';
export const GET_APP_STATUS = 'IS.APP.DISABLED';
export const GET_FIND_US = 'GET.FIND.US';
export const GET_HISTORY = 'GET.HISTORY';
export const GET_COMMON_FAQS = 'GET.COMMON.FAQS';
export const SEND_EMAIL = 'SEND.EMAIL';
export const GET_JOB_OPENINGS = 'JOB.OPENING';
export const GET_INVOICES = 'GET.INVOICES';
export const GET_RETURNS = 'GET.RETURNS';
export const GET_CUST_PHONE_MASK = 'GET.CUST.PHONE.MASK';
export const CHECK_CUST_PHONE = 'CHECK.CUST.PHONE';
export const LOGIN = 'LOGIN';
export const GET_USER_INFO = 'GET.USER.INFO';
export const GET_ACTIVE_ORDERS = 'GET.ACTIVE.ORDERS';
export const GET_ORDERS = 'GET.ORDERS';
export const GET_ORDERS_TIMELINE_DETAILS = 'GET.ORDERS.TIMELINE.DETAILS';
export const GET_SOA = 'GET.SOA';
export const GET_ACTIVATE_ACCOUNT_REQUEST = 'ACTIVATE.ACCOUNT.REQUEST';
export const UPDATE_USER_IMAGE = 'UPDATE.USER.IMAGE';
export const GET_OFFERS = 'GET.OFFERS';
export const GET_FEATURED_AND_BEST_SELLERS = 'GET.FEATURED.AND.BEST.SELLERS';
export const GET_ADV = 'GET.ADV';
export const GET_PRODUCTS = 'GET.PRODUCTS';
export const GET_CONSUMER_BRANDS = 'GET.CONSUMER.BRANDS';
export const OFFERS_ITEMS = 'OFFERS.ITEMS';
export const GET_PHARMAC_BRANDS = 'GET.PHARMAC.BRANDS';
export const ITEM_NUMBERS = 'ITEM.NUMBERS';
export const ITEMS_IN_BASKET = 'Items In Basket';
export const BASKET_LAST_UPDATE = 'BASKET.LAST.UPDATE';
export const ITEMS_MAP_IN_BASKET = 'Items Map In Basket';
export const GET_SAVE_USER_NOTIFICATIONS_SETTINGS = "GET.SAVE.USER.NOTIF.SETTINGS";
export const CHECK_IS_OTHER = 'IS.OTHER';
export const GET_BEST_SELLERS = 'GET.BEST.SELLERS';
export const GET_FEATURED_ITEMS = 'GET.FEATURED.ITEMS';

// Codes
export const networkError_code = 100;
export const basketItems = 'basketItems';
// Flags

// Inc. Dec.
export const DECREASE = 0;
export const INCREASE = 1;
export const SETQTY = 2;

// Reminders
export const EVERY_OTHER_DAY = 0;
export const EVERY_WEEK = 1;
export const CUSTOM_REMINDER = 2;

// true, false (str)
export const TRUE_STR = 'true';
export const FALSE_STR = 'false';

// Notification Types
export const out_for_delivery = 'OUT_FOR_DELIVERY';
export const rate_delivery = 'RATE_DELIVERY';

// Async Storage
export const language = 'language';
export const recNewsInfo = 'recNewsInfo';
export const invByEmail = 'invByEmail';
export const reminder = 'reminder';
export const customReminderDays = 'customReminderDays';
export const filters = 'filters';
export const categories = 'categories';
export const brands = 'brands';
export const cartItems = 'cartItems';

// Other
export const TOKEN = 'TOKEN';
export const PHONE = 'PHONE';
export const CUST_CODE = 'CUST_CODE';
export const CHECK_TOKEN = 'CHECK.TOKEN';
export const INVOICE_NO = 'INVOICE_NO';
export const INVOICE_DATE = 'INVOICE_DATE';
export const INVOICE_AMOUNT = 'INVOICE_AMOUNT';

// export const PRIVACY_POLICY_URL = 'https://www.freeprivacypolicy.com/privacy/view/453efa4956c2a81ae79ae4f341220419';
export const PRIVACY_POLICY_URL = 'http://mujeborganic.com/policy/MOF%20Privacy%20Policy.pdf';
export const CANCEL_AND_REFUND_POLICY_URL = 'http://mujeborganic.com/policy/MOF%20Cancel%20And%20Refund%20Policy.pdf';
export const TERMS_OF_SERVICE_POLICY_URL = 'http://mujeborganic.com/policy/MOF%20Terms%20of%20Service.pdf';
export const DELIVERY_POLICY_URL = 'http://mujeborganic.com/policy/MOF%20Delivery%20Policy.pdf';
export const CERTIFICATE_URL = 'https://sales.jdsco.net:8444/pick/faces/attachments/mojeb/docs/Certificate2023.pdf';
export const ACTIVATION_FORM = 'https://jdsco.net/whatsapp/activation%20agreement.doc';

export const INVOICE_DOWNLOAD_URL = serverBaseUrl + '/pick/faces/attachments/dumps/';

export const FACEBOOK_APP_ID = '728434854418381';
export const MIN_WIDTH = 1440;
export const MAX_WIDTH = 1440;
export const MOBILE_WIDTH = 1000;
export const SIDEBAR_WIDTH = 325;
export const VERSION = 'V49';

export var InvoiceNo = '';

